import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-high",
  "use": "icon-icn-high-usage",
  "viewBox": "0 0 10 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 14\" id=\"icon-icn-high\"><path d=\"M5.831.385l3.797 4.001c.492.517.496 1.362.011 1.886a1.196 1.196 0 01-1.767.011L6.25 4.575v8.092C6.25 13.403 5.69 14 5 14s-1.25-.597-1.25-1.333V4.473l-1.622 1.71a1.196 1.196 0 01-1.767-.011 1.397 1.397 0 01.01-1.886L4.075.385a1.195 1.195 0 011.757 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol